import type { Static } from 'runtypes';
import { Literal, Record } from 'runtypes';
import { CoreEventRuntype } from './core';
import { ClickstreamEventEnum } from 'bc-model';

const AccountCreatedEventRuntype = CoreEventRuntype.And(
  Record({
    event: Literal(ClickstreamEventEnum.ACCOUNT_CREATED),
    version: Literal(1),
  })
);

type AccountCreatedEvent = Static<typeof AccountCreatedEventRuntype>;

export { AccountCreatedEventRuntype, type AccountCreatedEvent };
